<template>
    <div class="uk-flex uk-flex-middle uk-flex-between uk-margin">
        <div class="uk-text-muted">
            <strong class="store-locator__results-total" data-uk-rr-grid-results-total>{{ storesCount }}</strong> {{ $t('rubinred.store-locator.messages.results_total') }}
        </div>
    </div>
</template>

<script>
    export default {
      props: {
        count: {
          type: Number,
          required: true,
        }
      },
      data() {
        return {
          storesCount: {
            type: Number,
            default: 0,
          }
        }
      },
      created() {
        let self = this;
        self.$root.$on('rubinred.store-locator.search.completed', results => {
          self.storesCount = results;
        });
      },
      mounted() {
        //initialize storesCount
        this.storesCount = this.count;
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/store-locator/assets/js/components/StoreLocatorCounter.vue